import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from '../../components/base/Sidebar/Sidebar';
import './relatorio.css';

function Relatorio() {
  const location = useLocation();
  const { disciplina, turma, relatorio, data } = location.state || {};

  const [titulo, setTitulo] = useState('');
  const [descricao, setDescricao] = useState('');
  const [observacoes, setObservacoes] = useState('');
  const [mensagem, setMensagem] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    setMensagem('Relatório enviado com sucesso!');
  };

  return (
    <div className='page-container'>
      <div className='menu'>
        <Sidebar />
      </div>
      <div className='content'>
        <h3>Relatório de {disciplina}</h3>
        <p><strong>Turma:</strong> {turma}</p>
        <p><strong>Nome do Relatório:</strong> {relatorio}</p>
        <p><strong>Data:</strong> {data}</p>

        <form onSubmit={handleSubmit} className="relatorio-form">
          <input 
            type="text" 
            placeholder="Título do Relatório" 
            value={titulo} 
            onChange={(e) => setTitulo(e.target.value)} 
            required
          />
          <textarea 
            placeholder="Descrição do relatório"
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
            required
          />
          <textarea 
            placeholder="Observações adicionais"
            value={observacoes}
            onChange={(e) => setObservacoes(e.target.value)}
          />

          {mensagem && <p className="success-message">{mensagem}</p>}
          <button className='button' type="submit">Enviar</button>
        </form>
      </div>
    </div>
  );
}

export default Relatorio;
